export const HOOKS_GET_SUCCESS = 'HOOKS_GET_SUCCESS'
export const HOOK_CREATE_SUCCESS = 'HOOK_CREATE_SUCCESS'
export const HOOK_DELETE_SUCCESS = 'HOOK_DELETE_SUCCESS'

